import { createContext, useContext, useEffect, useState } from "react";

const DEFAULT_RATES = { GBP: 1.0, EUR: 1.17, USD: 1.27 };
const SYMBOLS = { GBP: "£", EUR: "€", USD: "$" };

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem("jas_currency") || "GBP");
  const [rates] = useState(DEFAULT_RATES);

  useEffect(() => { localStorage.setItem("jas_currency", currency); }, [currency]);

  const symbol = SYMBOLS[currency] || "£";
  const convert = (gbpPrice) => Number(gbpPrice || 0) * (rates[currency] || 1);
  const format = (gbpPrice) => {
    const v = convert(gbpPrice);
    return new Intl.NumberFormat(currency === "GBP" ? "en-GB" : currency === "EUR" ? "de-DE" : "en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: v >= 100 ? 0 : 2,
    }).format(v);
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, symbol, rates, convert, format, currencies: ["GBP", "EUR", "USD"], symbols: SYMBOLS }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
